import React from 'react';

import SubHeading from '../SubHeading/SubHeading';
import './Newsletter.css';

const Newsletter = () => (
  <div className="app__newsletter">
    <div className="app__newsletter-heading">
      <SubHeading title="What's New " />
      <h1 className="headtext__cormorant">Hire A Guide ,have adventures</h1>
      <p className="p__opensans">Go for a Trek</p>
    </div>
    <div className="app__newsletter-input flex__center">
      <input type="email" placeholder="Enter your email address" />
      <button type="button" className="custom__button">Go</button>
    </div>
  </div>
);

export default Newsletter;
